module.exports = __webpack_public_path__ + "img/SMT_36_Ms_Eva_Lim.f8ff0af3.jpg";